
import { useCart } from '../context/CartContext';

export default function CartButton() {
  const { totalItems, setIsCartOpen } = useCart();

  return (
    <button
      onClick={() => setIsCartOpen(true)}
      className="relative w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center hover:bg-stone-200 transition-colors cursor-pointer group"
      aria-label="Open cart"
    >
      <i className="ri-shopping-bag-line text-stone-700 text-lg group-hover:scale-110 transition-transform"></i>
      {totalItems > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-r from-amber-400 to-yellow-300 text-stone-900 text-xs font-bold rounded-full flex items-center justify-center shadow-md">
          {totalItems > 9 ? '9+' : totalItems}
        </span>
      )}
    </button>
  );
}
